import { z } from "zod";

export const NotificationsResponseSchema = z.object({
  notifications: z.array(
    z.object({
      id: z.coerce.string(),
      type: z.string(),
      config: z.object({
        name: z.string(),
        webhook_url: z.string(),
      }),
    })
  ),
});
